import { render } from "./shipment_code.vue?vue&type=template&id=243a5dca"
import script from "./shipment_code.vue?vue&type=script&lang=js"
export * from "./shipment_code.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__